import classNames from 'classnames';
import { observer } from 'mobx-react';
import { Component } from 'react';
import { withOrderStore } from '../../context';
import getOrderCheckoutPath from '../../getOrderCheckoutPath';
import OrderMainInfo from './containers/OrderMainInfo/OrderMainInfo';
import OrderStatusButtons from './containers/OrderStatusButtons/OrderStatusButtons';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { HISTORY_ORDERS, ORDER_STATUS } from 'src/constants/order';
import theme from 'src/constants/styles';
import { USER_PERMISSIONS } from 'src/constants/user';
import { localeStore } from 'src/mobx/localesStore';
import { history } from 'src/services/history';
import AggregatorManager from 'src/view/components/AggregatorManager/AggregatorManager';
import CustomTooltip, { TOOLTIP_DURATION } from 'src/view/components/Controls/CustomTooltip/CustomTooltip';
import Icon from 'src/view/components/Controls/Icon/Icon';
import Permission from 'src/view/components/Permission/Permission';
import { AGGREGATORS } from '~/constants/aggregators';
import { OrderStore } from '~/mobx/orderStore';
import OrderStatusIcon from '~/view/components/OrderStatusIcon/OrderStatusIcon';
import './style.scss';
import { getNextStatus } from 'src/view/components/AggregatorManager/helpers/AggregatorManagerHelpers';
import { DELIVERY_TYPE } from '~/constants/deliveryTypes';

const notEditableOrderStatuses = [ORDER_STATUS.CANCELED, ORDER_STATUS.WAITING_FOR_PAYMENT, ORDER_STATUS.ON_HOLD];

// @ts-ignore
@withOrderStore
@observer
export default class OrderHeader extends Component<{ orderStore?: OrderStore }, {}> {
  get orderStore() {
    return this.props.orderStore!;
  }

  get historyStatus() {
    return (
      this.orderStore.order &&
      HISTORY_ORDERS.includes(this.orderStore.order.order_status_code) &&
      this.orderStore.order?.order_status_code !== ORDER_STATUS.COMPLETED
    );
  }
  get showStatusButton() {
    return (
      this.orderStore.order &&
      ![ORDER_STATUS.WAITING_FOR_PAYMENT, ORDER_STATUS.ON_HOLD, ORDER_STATUS.RETURNED].includes(this.orderStore.order?.order_status_code)
    );
  }

  /** Getter return boolean value wich one tell us if edit icon should be displayed or not
   * Order can not be edited:
   * - When order entity is missed or not loaded yet
   * - When order is coming from aggregator
   * - When order in not editable statuses
   *
   * In all other cases order can be edit
   */
  get isEditable(): boolean {
    return (
      !!this.orderStore.order &&
      !notEditableOrderStatuses.includes(this.orderStore.order.order_status_code) &&
      this.orderStore.order?.aggregator_key !== AGGREGATORS.DOOK
    );
  }

  clickEdit = () => {
    if (!this.orderStore.order) return;

    // this.orderStore.parentStore.setFilters({ type: ORDER_TYPE.DRAFT }, false, { notFetch: true });
    history.push(getOrderCheckoutPath(this.orderStore.parentStore, this.orderStore.order.id));
  };

  render() {
    return (
      <div className="mb-4">
        <header className={classNames('order-header px-3', { 'order-header_history': this.historyStatus })}>
          <div className="d-flex flex-row align-items-center">
            <OrderStatusIcon size={40} status={this.orderStore.order?.order_status_code as ORDER_STATUS} />
            <p className="order-header__order-status family-regular">{localeStore.t(`${this.orderStore.order?.order_status_code || ''}_status`)}</p>
            <hr className="order-header__horbar mx-3" />

            <AggregatorManager aggregator={this.orderStore.order?.aggregator_key} sectionName="phone">
              {this.orderStore.order?.stranger_phone ? (
                <CustomTooltip
                  message="order_someone_else_informing"
                  messageClassName="order-header__message"
                  duration={TOOLTIP_DURATION.EXTRA_LARGE}
                >
                  <div className="order-header__icon">
                    <Icon name={Icons.IcGift} size={20} color={theme.colors.graysection} />
                  </div>
                </CustomTooltip>
              ) : null}
            </AggregatorManager>

            <h1 className="order-header__order-id pl-1">#{this.orderStore.order?.order_key}</h1>

            <AggregatorManager aggregator={this.orderStore.order?.aggregator_key} sectionName="edit">
              {this.isEditable ? (
                <Permission permissions={USER_PERMISSIONS.ORDERS_EDIT}>
                  <div className="order-header__icon mr-2" onClick={this.clickEdit}>
                    <Icon name={Icons.Edit} size={18} />
                  </div>
                </Permission>
              ) : null}
            </AggregatorManager>
          </div>

          <AggregatorManager
            aggregator={this.orderStore.order?.aggregator_key}
            sectionName="statusManagment"
            currentStatus={this.orderStore.order?.order_status_code}
            nextStatus={getNextStatus(this.orderStore.order)}
            deliveryType={this.orderStore.order?.delivery_type_code}
          >
            <Permission permissions={USER_PERMISSIONS.ORDERS_MANAGMENT}>{this.showStatusButton ? <OrderStatusButtons /> : null}</Permission>
          </AggregatorManager>
        </header>

        <OrderMainInfo />
      </div>
    );
  }
}
